export default {
  undoCount: state => state.undo.length,
  redoCount: state => state.redo.length,
  hasUnsaveChanges: state => state.hasUnsaveChanges,
}
